import { format } from "date-fns";
import { API_TBase } from "./API";
import { API_TUser } from "./auth";

export type API_TNote = {
  message: string;
  user_id: number;
  type: string;
  case_id: number;
  user: API_TUser;
} & API_TBase;

export type TNote = {
  message: string;
};

export type TNote_Table = {
  id: number;
  message: string;
  name: string;
  date: string;
  type: string;
};

export const convertNotesForTable = (a: API_TNote): TNote_Table => {
  const formatStr = "dd/MM/yyyy hh:mm";
  const date = new Date(a.CreatedAt);
  return {
    id: a.ID,
    message: a.message,
    name: a.user.first_name || a.user.last_name ? a.user.first_name + " " + a.user.last_name : "-",
    date: format(date, formatStr) || "-",
    type: a.type,
  };
};
